import * as tslib_1 from "tslib";
import { AuthorizeBaseDirective } from './authorize-base.directive';
var FolderAuthorizeDirective = /** @class */ (function (_super) {
    tslib_1.__extends(FolderAuthorizeDirective, _super);
    function FolderAuthorizeDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FolderAuthorizeDirective.prototype, "permissionDisable", {
        set: function (permission) {
            this._permissionExpression = permission;
            this._trySetPermission();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FolderAuthorizeDirective.prototype, "folderId", {
        set: function (id) {
            this._folderId = id;
            this._trySetPermission();
        },
        enumerable: true,
        configurable: true
    });
    FolderAuthorizeDirective.prototype._isGranted = function (permission) {
        return this._appState.user.folderPermissions.isGranted(this._folderId, permission);
    };
    FolderAuthorizeDirective.prototype._trySetPermission = function () {
        if (this._folderId == null || this._permissionExpression == null) {
            return;
        }
        this._permissionDisable = this._permissionExpression;
    };
    return FolderAuthorizeDirective;
}(AuthorizeBaseDirective));
export { FolderAuthorizeDirective };
